import EmptyPage from '../../components/empty-page/emptyPage';

const TripKeywordTable = ({
    keywords = [],
    loading,
    offset,
    handleToggleStatus,
    handleEdit,
    setDeleteModal,
    setRowClickId
}) => {
    if (loading) {
        return <div className='tableLoader'>Loading...</div>;
    }

    const capitalizeWords = (text) => {
        return text
            ?.split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    if (keywords?.length === 0) {
        return <EmptyPage />;
    }
    return (
        <div className='tableContainer'>
            <table className='table'>
                <thead className='tableHead'>
                    <tr>
                        <th style={{ textAlign: 'center' }}>#</th>
                        <th>Keyword</th>
                        <th>Types</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {keywords.map((item, index) => (
                        <tr key={item._id}>
                            <td style={{ textAlign: 'center' }}>{offset + index + 1}</td>

                            <td>{capitalizeWords(item.keyword)}</td>
                            <td>{capitalizeWords(item.types?.join(', ') || '-')}</td>
                            <td>
                                <span className={item.isActive ? 'status active' : 'status inactive'}>
                                    {item.isActive ? 'Active' : 'Inactive'}
                                </span>
                            </td>

                            <td>
                                <button
                                    className='actBtn billBtn noWidth'
                                    onClick={() => {
                                        setDeleteModal(true);
                                        setRowClickId(item._id);
                                    }}
                                >
                                    Delete
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className='responsiveCardContainer'>
                {keywords?.map((row, rowIndex) => (
                    <div key={rowIndex} className='responsiveCard'>
                        <div className='cardContent'>
                            <p>
                                <strong>Keyword:</strong> {capitalizeWords(row?.keyword) ?? 'N/A'}
                            </p>
                            <p className='bookingCardLabelDisplay'>
                                <strong>Status:</strong> {row?.isActive ? 'Active' : 'Inactive'}
                            </p>
                            <p>
                                <strong>Actions:</strong>{' '}
                                <button
                                    className='actBtn billBtn noWidth'
                                    onClick={() => {
                                        setDeleteModal(true);
                                        setRowClickId(row._id);
                                    }}
                                >
                                    Delete
                                </button>
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TripKeywordTable;
